module.exports = __webpack_public_path__ + "static/media/Ayurvedic_Products_m_mr.fd5f91b4.jpg";